import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "shape-animation" }
const _hoisted_2 = ["viewBox"]

import { computed, onMounted, ref } from "vue";

const shapeWidth = 1000;
const motionSpline = ".25 .75 .75 .25";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonShapeAnimation',
  props: {
    shape: {},
    sides: {},
    rotation: {},
    duration: {},
    position: {}
  },
  setup(__props: any) {

const svg = ref<SVGSVGElement | null>(null);
const props = __props;

const shape = computed(() => props.shape || "circle");
const duration = computed(() => props.duration || 3);
const decay = computed(() => duration.value / 8);
const shapePosition = computed(() => {
    if (props.position == undefined) {
        return "";
    }
    return props.position;
});

const degreeToRadian = (deg: number) => deg * Math.PI / 180;

onMounted(() => {
    if (svg.value) {
        const svgElement = svg.value;
        const svgNS = svgElement.namespaceURI;
        const radius = shapeWidth / 20;
        let i;

        if (shape.value == "circle") {
            const circle = document.createElementNS(svgNS, "circle") as SVGCircleElement;
            circle.setAttribute("cx", "0");
            circle.setAttribute("cy", "0");
            circle.setAttribute("r", radius.toString());
            circle.setAttribute("opacity", "0");

            for (i = 0; i < 4; i++) {
                let _circle = circle.cloneNode(true) as SVGCircleElement;
                _circle.innerHTML = `
                    <animate attributeName="r" values="${radius};${radius * 5};${radius * 15}" calcMode="spline" keyTimes="0;.5;1" keySplines="${motionSpline};${motionSpline}" dur="${duration.value}s" begin="${i * decay.value}s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0;1;.75;.5;0" dur="${duration.value}s" begin="${i * decay.value}s" repeatCount="indefinite" />
                `;
                svgElement.appendChild(_circle);
            }

        } else {
            const sides = props.sides || 3;
            const points = [];
            const angle = Math.PI * 2 / sides;

            for (i = 0; i < sides; i++) {
                const rotatedAngle = angle * i + (props.rotation ? degreeToRadian(props.rotation) : 0);
                const x = radius * Math.cos(rotatedAngle);
                const y = radius * Math.sin(rotatedAngle);
                points.push(`${x},${y}`);
            }

            const polygon = document.createElementNS(svgNS, "polygon") as SVGPolygonElement;
            polygon.setAttribute("points", points.join(" "));
            polygon.setAttribute("opacity", "0");

            for (i = 0; i < 4; i++) {
                let _polygon = polygon.cloneNode(true) as SVGPolygonElement;
                _polygon.innerHTML = `
                    <animateTransform attributeName="transform" type="scale" from="1" to="20" calcMode="spline" keyTimes="0;1" keySplines="${motionSpline}" dur="${duration.value}s" begin="${i * decay.value}s" repeatCount="indefinite" />
                    <animate attributeName="stroke-width" from=".5" to=".05" calcMode="spline" keyTimes="0;1" keySplines="${motionSpline}" dur="${duration.value}s" begin="${i * decay.value}s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0;1;.75;.5;0" dur="${duration.value}s" begin="${i * decay.value}s" repeatCount="indefinite" />
                `;
                svgElement.appendChild(_polygon);
            }
        }

    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["shape-container", shapePosition.value])
    }, [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `${-shapeWidth} ${-shapeWidth} ${shapeWidth} ${shapeWidth}`,
        ref_key: "svg",
        ref: svg
      }, null, 8, _hoisted_2))
    ], 2)
  ]))
}
}

})